import {
  Card,
  CardContent,
  CardHeader,
  CardTitle,
} from "@bcc/components/ui/card";
import { useTranslation } from "react-i18next";
import {
  Bar,
  BarChart,
  Cell,
  ResponsiveContainer,
  Tooltip,
  XAxis,
  YAxis,
} from "recharts";
import {
  setOrdersByProductChartTestId,
  setOrdersByProductChartTitleTestId,
} from "./orders-by-product-chart.utils";

export interface ProductData {
  product: string;
  orders: number;
  color: string;
}

interface OrdersByProductChartProps {
  data: ProductData[];
  testId?: string;
}

interface ProductBarProps {
  data: ProductData[];
}

function ProductBars({ data }: ProductBarProps) {
  return (
    <Bar dataKey="orders" radius={[0, 4, 4, 0]}>
      {data.map((entry, index) => (
        <Cell key={`cell-${index}`} fill={entry.color} />
      ))}
    </Bar>
  );
}

export function OrdersByProductChart({
  data,
  testId,
}: OrdersByProductChartProps) {
  const { t } = useTranslation();
  return (
    <Card testId={testId ?? setOrdersByProductChartTestId("container")}>
      <CardHeader>
        <CardTitle
          className="text-xl font-semibold"
          data-testid={setOrdersByProductChartTitleTestId()}
        >
          {t("dashboardComponents.ordersByProductChart.title")}
        </CardTitle>
      </CardHeader>
      <CardContent>
        <div className="h-[320px]">
          <ResponsiveContainer width="100%" height="100%">
            <BarChart data={data} layout="vertical">
              <XAxis
                type="number"
                className="text-xs"
                tick={{ fill: "hsl(var(--muted-foreground))" }}
              />
              <YAxis
                type="category"
                dataKey="product"
                className="text-xs"
                tick={{ fill: "hsl(var(--muted-foreground))" }}
                width={120}
              />
              <Tooltip
                contentStyle={{
                  backgroundColor: "hsl(var(--card))",
                  border: "1px solid hsl(var(--border))",
                  borderRadius: "8px",
                }}
                formatter={(value) => [
                  value ?? 0,
                  t("dashboardComponents.ordersByProductChart.orders"),
                ]}
              />
              <ProductBars data={data} />
            </BarChart>
          </ResponsiveContainer>
        </div>
      </CardContent>
    </Card>
  );
}
